import React from "react";
import { GradeCondition } from "../../graphql/generated/graphql";
import { GradeConditionLabels } from "../../options";

interface GradeConditionsProps {
  selectedGradeConditions: GradeCondition[] | null;
  setSelectedGradeConditions: (
    newGradeConditions: GradeCondition[] | null
  ) => void;
}

const GradeConditions: React.FC<GradeConditionsProps> = ({
  selectedGradeConditions,
  setSelectedGradeConditions,
}) => {
  const handleGradeConditionsChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value, checked } = event.target;

    if (Object.values(GradeCondition).includes(value as GradeCondition)) {
      const updatedConditions = selectedGradeConditions
        ? [...selectedGradeConditions]
        : [];

      if (checked) {
        updatedConditions.push(value as GradeCondition);
      } else {
        setSelectedGradeConditions(
          updatedConditions.filter((item) => item !== value)
        );
        return;
      }

      setSelectedGradeConditions(updatedConditions);
    }
  };

  return (
    <div>
      <label htmlFor="gradeconditions">مقطع</label>
      {Object.entries(GradeConditionLabels).map(([key, label]) => (
        <div key={key} className="flex gap-1">
          <input
            type="checkbox"
            id={key}
            name="GradeConditions"
            value={key}
            checked={
              selectedGradeConditions?.includes(key as GradeCondition) ?? false
            }
            onChange={handleGradeConditionsChange}
            className="w-4"
          />
          <label htmlFor={key}>{label}</label>
        </div>
      ))}
    </div>
  );
};

export default GradeConditions;
